import axios from 'axios';
import humps from 'humps';

export interface ApiError {
  code?: string;
  title?: string;
}

const host: string | undefined = process.env.REACT_APP_API_BASE_URL;

const instance = axios.create({
  baseURL: `${host}/api/v1/`,
  withCredentials: true,
  validateStatus: function (status) {
    // if (status === 403) {
    //   // window.location.href = '/companies';
    // }
    return status >= 200 && status < 300; // default
  },
});

instance.interceptors.request.use(async (config) => {
  config.data = humps.decamelizeKeys(config.data);
  config.params = humps.decamelizeKeys(config.params);

  return config;
});

instance.interceptors.response.use((response) => {
  const data = humps.camelizeKeys(response.data);

  return { ...response, data };
});

export default instance;
